import { mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'

export default {
  methods: {
    ...mapActions({
      addToastMessage: ADD_TOAST_MESSAGE
    }),
    addToast (params) {
      this.addToastMessage(params)
    },
    addToastWarning (message, dismissAfter) {
      this.addToastMessage({
        text: message,
        type: 'warning',
        dismissAfter: dismissAfter || 4000
      })
    },
    addToastInfo (message, dismissAfter) {
      this.addToastMessage({
        text: message,
        type: 'info',
        dismissAfter: dismissAfter || 4000
      })
    },
    addToastSuccess (message, dismissAfter) {
      this.addToastMessage({
        text: message,
        type: 'success',
        dismissAfter: dismissAfter || 4000
      })
    },
    addToastDanger (message, dismissAfter) {
      this.addToastMessage({
        text: message,
        type: 'danger',
        dismissAfter: dismissAfter || 4000
      })
    }
  }
}
